import React from 'react';
import { LibraryQuestionList } from './components/LibraryQuestionList';

export function LibraryLandingPage() {
  return <LibraryQuestionList />;
}
